exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".workflow-parameters-editor-container {\n  width: 100%;\n}\n.workflow-parameters-editor-container .ant-collapse-extra {\n  margin-left: auto;\n}\n.workflow-parameters-editor-container .ant-form-item-control-input {\n  min-height: 0;\n}\n.workflow-parameters-editor-container .ant-row.ant-form-item {\n  margin: 0;\n  padding: 0;\n}\n.workflow-parameters-editor-container .loader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 5px;\n}\n", ""]);

// exports
